import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import axios from 'axios';
import {API_BASED_URL} from '../config.js'; 

const ModPassword = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [showPass, setShowPass] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('userToken'); 

        try {
            const response = await axios.post(
                `${API_BASED_URL}api/modifypassword`,
                { email, password },
                {
                    headers: {
                        Authorization: `${token}`,
                    },
                }
            );
            setMessage('Password changed successfully');
        } catch (error) {
            setMessage('Error changing password');
        }
    };

    return (
        <div>
            <h2>Modify Password</h2>
            <form onSubmit={handleSubmit}>
                <div>
                    <label>Email ID:</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>New Password:</label>
                    <div className="relative">
                        <input
                            type={showPass ? 'text' : 'password'}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="pr-10"
                        />
                        <button type="button" aria-label={showPass ? 'Hide password' : 'Show password'} onClick={()=>setShowPass(v=>!v)} className="absolute right-2 top-1/2 -translate-y-1/2 inline-flex w-7 h-7 items-center justify-center p-0.5 rounded-md text-gray-500 hover:text-gray-700 bg-transparent hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500">{showPass ? <EyeOff size={18}/> : <Eye size={18}/>}</button>
                    </div>
                </div>
                <button type="submit">Change Password</button>
            </form>
            {message && <p>{message}</p>}
        </div>
    );
};

export default ModPassword;